import { render, staticRenderFns } from "./DiscussionModule.vue?vue&type=template&id=4c484442&"
import script from "./DiscussionModule.vue?vue&type=script&lang=js&"
export * from "./DiscussionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports